import { useEffect, useState } from 'react';

function useDebounce(value, delay) {
    const [debouncedValue, setDebouncedValue] = useState(value);
    const sanitizedDelay = Math.max(0, Number(delay) || 0);

    useEffect(() => {
        const t = setTimeout(() => {
            setDebouncedValue(value);
        }, sanitizedDelay);

        return () => clearTimeout(t);
    }, [value, sanitizedDelay]);

    return debouncedValue;
}

export default useDebounce;
